<template>
<div>
    <filters-form @filtersSubmited="onFiltersSubmited" />

    <el-data-table 
        :resourceUrl="baseUrl"
        :externalFiltersValid="filters.valid || false"
        ref="dataTable">

        <template slot="tableActions">
            <a :disabled="downloadUrl == null" slot="top-buttons" class="btn btn-default btn-sm" @click="downloadReport()"><i class="fa fa-download"></i> Descargar CSV</a>
        </template>

        <template slot="columns">
            <el-table-column
                prop="date_from"
                width="95"
                align="center"
                label="Desde">
            </el-table-column>
            <el-table-column
                prop="date_to"
                width="95"
                align="center"
                label="Hasta">
            </el-table-column>
            <el-table-column
                prop="company_id_number"
                width="90"
                align="right"
                label="Código">
            </el-table-column>
            <el-table-column
                prop="id_number"
                width="100"
                align="right"
                label="Cédula">
            </el-table-column>
            <el-table-column
                prop="employee_name"
                min-width="150"
                label="Empleado">
            </el-table-column>
            <el-table-column
                prop="functional_area_description"
                min-width="120"
                label="Área">
            </el-table-column>
            <el-table-column
                prop="roster_description"
                min-width="110"
                label="Nómina">
            </el-table-column>
            <el-table-column
                prop="amount"
                width="120"
                align="right"
                label="Monto">
                <template slot-scope="scope">
                    <strong>{{ formatCurrency(scope.row.amount) }}</strong>
                </template>
            </el-table-column>
            <el-table-column
                prop="observation"
                min-width="150"
                label="Observación">
                <template slot-scope="scope">
                    {{ scope.row.observation || '-' }}
                </template>
            </el-table-column>
            <el-table-column
                prop="created_by_name"
                width="140"
                label="Registrado por">
                <template slot-scope="scope">
                    {{ scope.row.created_by_name || 'Sistema' }}
                </template>
            </el-table-column>
            <el-table-column
                prop="created_at"
                width="150"
                align="center"
                label="Fecha Registro">
                <template slot-scope="scope">
                    {{ scope.row.created_at || '-' }}
                </template>
            </el-table-column>
        </template>

    </el-data-table>

</div>
</template>

<script>
    import filters_form from './filters-form.vue';
    import el_data_table from '../el-data-table.vue';

    export default {
        data() {
            return {
                baseUrl: '/reports/bonuses',
                downloadUrl: null,
                filters: {},
            }
        },
        watch: {
            '$route': function (to) {
                this.setDownloadUrl();
            }
        },
        mounted: function () {
            this.setDownloadUrl();
        },
        components: {
            'filters-form': filters_form,
            'el-data-table': el_data_table,
        },
        methods: {
            onFiltersSubmited(filters) {
                this.filters = filters;
            },
            setDownloadUrl: function () {
                this.queryString = $.param(this.$route.query);
                if (this.$route.query.date_from != undefined 
                    && this.$route.query.date_to != undefined 
                    && this.$route.query.date_from != null 
                    && this.$route.query.date_to != null) {
                    this.downloadUrl = '/api' + this.baseUrl + '/download?' + this.queryString;
                } else {
                    this.downloadUrl = null;
                }
            },
            downloadReport: function () {
                if (this.downloadUrl != null) {
                    window.location.href = this.downloadUrl + '&token=' + localStorage.getItem('id_token');
                }
            },
            formatCurrency(val) {
                if (val === null || val === undefined) return '$0';
                return '$' + Number(val).toLocaleString('es-CO', { minimumFractionDigits: 0, maximumFractionDigits: 2 });
            }
        }
    }
</script>
